/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationtabmessages2Inputs */

const en_moderationtabmessages2 = /** @type {(inputs: Moderationtabmessages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message reports`)
};

const de_moderationtabmessages2 = /** @type {(inputs: Moderationtabmessages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachrichtenmeldungen`)
};

/**
* | output |
* | --- |
* | "Message reports" |
*
* @param {Moderationtabmessages2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationtabmessages2 = /** @type {((inputs?: Moderationtabmessages2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationtabmessages2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationtabmessages2(inputs)
	return de_moderationtabmessages2(inputs)
});
export { moderationtabmessages2 as "moderationTabMessages" }